// Shown whenever an account is refused this app: by the login endpoint (loginUserSaga)
// and by a route whose permissions the signed-in user turns out not to have. One string
// so both paths read identically to the user.
export const NO_PERMISSION_ERROR =
  'Your account does not have permission to access this application';

export default NO_PERMISSION_ERROR;
